module.exports = __webpack_public_path__ + "static/media/liveIcon.f75013f9.svg";